import Loadable from "../../react-loadable";
const Calendar = Loadable({
  loader: () => import("./Calendar.jsx"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default Calendar;



// WEBPACK FOOTER //
// ./_antd1.11.2/calendar/index.jsx